import genLinkParams from '@/lib/generateLinkParams'
import { StyledContent } from '@/components/styles'
import Icon from '@/assets/icons'
import Link from 'next/link'

export default function ContentParentLink({ type, parentSlug, slug, children }) {
  const [href, as] = genLinkParams({ type, slug, parentSlug })

  return (
    <Link href={href} as={as} passHref>
      <StyledContent.ParentLink>
        <Icon name="arrow-left" />
        {children}
      </StyledContent.ParentLink>
    </Link>
  )
}
